import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {LabManagerService} from "../lab-manager.service";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {LabManagerSharedDataService} from "../lab-manager-shared-data.service";
import {AgronimistModel} from "../../models/lab-manager/agronimist";
import {AuthService} from "../../auth.service";
import {User} from "../../models/user";
import {MatDialog} from "@angular/material/dialog";
import {AttachItemComponent} from "../../order-to-cash/components-otc/dialogs-otc/attach-item/attach-item.component";
import {
  DraftConfirmationDialogComponent
} from "../../dialogs/draft-confirmation-dialog/draft-confirmation-dialog.component";
import {
  EditAttachmentComponent
} from "../../order-to-cash/components-otc/dialogs-otc/edit-attachment/edit-attachment.component";
import {Attachment} from "../models/attachment";
import {LabSubmissionDetailsModel} from "../../models/lab-manager/lab-submission-details";
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-lab-results',
    templateUrl: './lab-results.component.html',
    styleUrls: ['./lab-results.component.css'],
    standalone: false
})
export class LabResultsComponent implements OnInit {
  @Input() resultsAreCorrect: boolean = false;
  @Output() emitCorrectResults = new EventEmitter();
  canApprove: boolean = false;
  uploadDate = new Date();
  labSubmissionDetails: LabSubmissionDetailsModel;
  tableHeight: string = '';
  attachments: Attachment[] = [];

  constructor(
      private labManagerService: LabManagerService,
      private nav: NavBarComponent,
      private route: ActivatedRoute,
      private labManagerSharedDataService: LabManagerSharedDataService,
      private authService: AuthService,
      private dialog: MatDialog
  ) {
    // takeUntilDestroyed on both: this component is created and destroyed by an
    // *ngIf on the parent every time the user moves between tabs, so an undisposed
    // subscription here accumulates one dead handler per visit.
    labManagerSharedDataService.isApproverData$.pipe(takeUntilDestroyed()).subscribe(res => {
      this.canApprove = res;
    });

    labManagerSharedDataService.labSubmissionDetailsData$.pipe(takeUntilDestroyed()).subscribe(res => {
      if(res) {
        this.labSubmissionDetails = res;
        this.retrieveLabAttachments();
      }
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.tableHeight = (window.innerHeight - 390) + 'px';
  }

  ngOnInit() {
    this.resultsAreCorrect = false;
    this.emitCorrectResults.emit(this.resultsAreCorrect);
    this.onResize();
  }

  retrieveLabAttachments(changeToAttachments?: boolean) {
    this.labManagerService.retrieveLabResultAttachments(this.labSubmissionDetails.id).subscribe({
      next: (res) => {
        this.attachments = res;
        if(changeToAttachments) {
          this.nav.toggleLoading(false);
        }
      }
    })
  }

  removeLabResultAttachment(attachmentId: number) {
    const dialogRef = this.dialog.open(DraftConfirmationDialogComponent, {
      data: {
        dialogType: 'delete',
        dialogTitle: 'DELETE ATTACHMENT',
        dialogSubTitle: 'Are you sure you want to delete this attachment?'
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if(res) {
          this.nav.toggleLoading(true);
          this.labManagerService.deleteLabResultAttachment(attachmentId).subscribe({
            next: () => {
              this.retrieveLabAttachments(true);
            },
            error: () => {
              this.nav.toggleLoading(false);
            }
          })
        }
      }
    })
  }

  downloadLabResultAttachment(attachment: Attachment) {
    this.nav.toggleLoading(true);
    this.labManagerService.downloadLabResultAttachment(attachment.id).subscribe({
      next: (res) => {
        const file = new Blob([res], { type: 'application/*' });
        const url = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = attachment.documentName;
        link.click();
        window.URL.revokeObjectURL(url);
        this.nav.toggleLoading(false);
      }
    })
  }

  editLabResultAttachment(attachment) {
    const dialogRef = this.dialog.open(EditAttachmentComponent, {
      data: {
        isLabManagerComp: true,
        description: attachment.description,
        fileName: attachment.documentName,
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if(res?.description) {
        this.nav.toggleLoading(true);
        this.labManagerService.updateLabResultAttachmentDescription(attachment.id, res.description).subscribe({
          next: (res) => {
            this.retrieveLabAttachments(true);
          },
          error: () => {
            this.nav.toggleLoading(false);
          }
        })
      }
    })
  }

  openAttachFileDialog() {
    const dialogRef = this.dialog.open(AttachItemComponent, {
      data: {
        isLabManagerComp: true
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if(res?.fileObj) {
        this.nav.toggleLoading(true);
        this.labManagerService.addFileToLabResult(this.labSubmissionDetails.id, res.description, res.fileObj).subscribe({
          next: (res) => {
            this.retrieveLabAttachments(true);
          },
          error: () => {
            this.nav.toggleLoading(false);
          }
        });
      }
    })
  }
}
